/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  'use strict';

  // ═══════════════════════════════════════════════════════
  // Add-to-Cart: Per-Button Debounce
  // ─────────────────────────────────────────────────────
  // Prevents double-clicks on the same add-to-cart button.
  // Uses capture phase to fire before the theme's handler.
  // Each button gets an independent 3s cooldown; clicking
  // different buttons rapidly is still allowed (the fetch
  // queue batches those into a single API call).
  // ═══════════════════════════════════════════════════════

  var BUTTON_COOLDOWN = 3000;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    if (btn.dataset.ddCooldown) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    btn.dataset.ddCooldown = '1';
    setTimeout(function() { delete btn.dataset.ddCooldown; }, BUTTON_COOLDOWN);
  }, true);

  // ═══════════════════════════════════════════════════════
  // Quick Add Modal: Variant Picker
  // ─────────────────────────────────────────────────────
  // The api-product-upsell section is fetched via AJAX and
  // inserted via innerHTML, which means inline <script> tags
  // never execute. This page-level script listens for the
  // theme:quick-add:open event and initialises handlers.
  // ═══════════════════════════════════════════════════════

  document.addEventListener('theme:quick-add:open', function() {
    setTimeout(initQuickAddModal, 120);
  });

  function initQuickAddModal() {
    var modal = document.querySelector('[data-quick-add-modal][open]');
    if (!modal) return;
    if (modal.getAttribute('data-dd-init') === '1') return;
    modal.setAttribute('data-dd-init', '1');

    initQuickAddVariants(modal);
  }

  /* ── Variant picker ── */
  function initQuickAddVariants(modal) {
    var jsonEl = modal.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); }
    catch (e) { return; }
    if (!product || !product.variants || product.variants.length <= 1) return;

    var idInput = modal.querySelector('input[name="id"]');
    var optionInputs = modal.querySelectorAll('[data-single-option-selector]');
    var priceEl = modal.querySelector('[data-product-price]');
    var compareEl = modal.querySelector('[data-compare-price]');
    var addBtn = modal.querySelector('[data-add-to-cart]');
    var addText = modal.querySelector('[data-add-to-cart-text]');

    if (!optionInputs.length) return;

    function getSelectedOptions() {
      var opts = {};
      optionInputs.forEach(function(input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          if (input.checked) opts[input.getAttribute('data-index')] = input.value;
        } else {
          opts[input.getAttribute('data-index')] = input.value;
        }
      });
      var arr = [];
      for (var i = 1; i <= 3; i++) {
        if (opts['option' + i] !== undefined) arr.push(opts['option' + i]);
      }
      return arr;
    }

    function findVariant(options) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v.options[j] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function onVariantChange() {
      var options = getSelectedOptions();
      var variant = findVariant(options);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id.toString();
      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      // Switch image to variant's featured image
      if (variant.featured_media) {
        var imgContainer = modal.querySelector('product-images');
        if (imgContainer) {
          var sectionId = modal.getAttribute('data-section-id') || '';
          var target = imgContainer.querySelector('[data-media-id="' + sectionId + '-' + variant.featured_media.id + '"]');
          if (target) {
            var allSlides = imgContainer.querySelectorAll('[data-image-id]');
            for (var i = 0; i < allSlides.length; i++) {
              allSlides[i].classList.remove('media--active');
              allSlides[i].classList.add('media--hidden');
            }
            target.classList.add('media--active');
            target.classList.remove('media--hidden');
          }
        }
      }
    }

    optionInputs.forEach(function(input) {
      input.addEventListener('change', onVariantChange);
    });
  }

  // ═══════════════════════════════════════════════════════
  // Mingle "Share your cart" – move below checkout
  // ─────────────────────────────────────────────────────
  // The Mingle Cart Share app embed injects its button
  // dynamically inside the cart drawer body. We relocate
  // the entire widget container into drawer__foot so it
  // appears right below the checkout button.
  // ═══════════════════════════════════════════════════════

  function relocateMingleButton() {
    var drawer = document.querySelector('.drawer--cart');
    if (!drawer) return false;

    var foot = drawer.querySelector('.drawer__foot');
    if (!foot) return false;

    // Already relocated?
    if (foot.querySelector('[data-dd-mingle]')) return true;

    // Find the Mingle button by its text content
    var allBtns = drawer.querySelectorAll('a, button');
    var mingleEl = null;
    for (var i = 0; i < allBtns.length; i++) {
      var txt = allBtns[i].textContent.trim().toLowerCase();
      if (txt === 'share your cart' || txt.indexOf('share your cart') !== -1) {
        mingleEl = allBtns[i];
        break;
      }
    }
    if (!mingleEl) return false;

    // Walk up to find the outermost Mingle container
    // Stop before hitting any structural drawer elements
    var STOP_CLASSES = ['drawer__body', 'drawer__inner', 'drawer__recs-panel', 'drawer__foot', 'drawer__empty'];
    var container = mingleEl;
    while (container.parentElement) {
      var parent = container.parentElement;
      var stop = false;
      for (var j = 0; j < STOP_CLASSES.length; j++) {
        if (parent.classList.contains(STOP_CLASSES[j])) { stop = true; break; }
      }
      if (stop || parent.hasAttribute('data-cart-drawer-body') ||
          parent.hasAttribute('data-cart-recs-panel') ||
          parent.tagName === 'CART-DRAWER' ||
          parent.tagName === 'COLLAPSIBLE-ELEMENTS') break;
      container = parent;
    }

    // Safety: never move a structural element itself
    for (var k = 0; k < STOP_CLASSES.length; k++) {
      if (container.classList.contains(STOP_CLASSES[k])) return false;
    }

    // Mark it so we don't re-process
    container.setAttribute('data-dd-mingle', '1');

    // Move the entire container into the footer
    foot.appendChild(container);

    return true;
  }

  // Run on cart drawer open and observe for late-injecting apps
  var mingleObserver = null;

  function startMingleWatch() {
    if (relocateMingleButton()) return;

    // Mingle may inject after a delay; watch for it
    if (mingleObserver) return;
    var drawer = document.querySelector('.drawer--cart');
    if (!drawer) return;

    mingleObserver = new MutationObserver(function() {
      if (relocateMingleButton()) {
        mingleObserver.disconnect();
        mingleObserver = null;
      }
    });
    mingleObserver.observe(drawer, { childList: true, subtree: true });

    // Safety: stop observing after 10s
    setTimeout(function() {
      if (mingleObserver) {
        mingleObserver.disconnect();
        mingleObserver = null;
      }
    }, 10000);
  }

  // Listen for cart drawer open events
  document.addEventListener('theme:cart:open', startMingleWatch);
  document.addEventListener('theme:cart-drawer:open', startMingleWatch);

  // Also run on DOMContentLoaded in case drawer is already open
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMingleWatch);
  } else {
    startMingleWatch();
  }

  // ═══════════════════════════════════════════════════════
  // Wholesale: Live Price + Quick Order
  // ─────────────────────────────────────────────────────
  // Display only. Wholesale prices are applied at checkout
  // by the automatic discount in Shopify admin.
  // ═══════════════════════════════════════════════════════

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);

    function withDelimiters(decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(0, '.', ','); break;
      default: value = withDelimiters(2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  // Keep the product page wholesale price in sync with the selected variant.
  document.addEventListener('theme:variant:change', function(e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !e.target.querySelectorAll) return;

    e.target.querySelectorAll('[data-wholesale-live]').forEach(function(el) {
      var percent = parseInt(el.dataset.wholesalePercent, 10) || 0;
      var amount = el.querySelector('[data-wholesale-price-amount]');
      if (!amount) return;
      amount.textContent = formatMoney(Math.round(variant.price * (100 - percent) / 100));
    });
  });

  // Quick order: add every row with a quantity to the cart in one request.
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-wholesale-quick-order-form]');
    if (!form) return;
    e.preventDefault();

    var error = form.querySelector('[data-wholesale-quick-order-error]');
    var button = form.querySelector('[data-wholesale-quick-order-submit]');
    var items = [];

    form.querySelectorAll('[data-variant-id]').forEach(function(input) {
      var quantity = parseInt(input.value, 10);
      if (quantity > 0) items.push({ id: Number(input.dataset.variantId), quantity: quantity });
    });

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
    }

    error.hidden = true;
    if (!items.length) {
      showError('Enter a quantity for at least one item.');
      return;
    }

    button.disabled = true;
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        });
      })
      .then(function() {
        window.location.href = window.theme.routes.cart_url;
      })
      .catch(function(err) {
        showError(err.message);
        button.disabled = false;
      });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
